import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { first } from 'rxjs/operators';
import { ModalRecuperarComponent } from '../modal-recuperar/modal-recuperar.component';
import { ModalRegisterComponent } from '../modal-register/modal-register.component';
import { AccountService } from '../../_services/account.service';
import { HttpResponse } from '@angular/common/http';
import { User } from '../../_models/user';

@Component({
  selector: 'app-modal-login',
  templateUrl: './modal-login.component.html',
  styleUrls: ['./modal-login.component.css']
})
export class ModalLoginComponent implements OnInit {
  form: FormGroup;
  submitted = false;
  rutaRegister: string;
  rutaRecuperar: string;
  errorLogin = false;
  errorMsg = '';
  

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private accountService: AccountService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      username: ['', Validators.compose([Validators.required,Validators.email])],
      password: ['', Validators.required]
    });
    
    this.rutaRegister = this.router.url.split('#')[0];
    this.rutaRecuperar = this.router.url.split('#')[0];    
  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  onSubmit() {
    this.submitted = true;
    this.errorLogin = false;

    // stop here if form is invalid
    if (this.form.invalid) {
        return;
    }

    //this.loading = true;
    this.accountService.login(this.f.username.value, this.f.password.value).subscribe(data => {
      if(data instanceof HttpResponse) {
        var response = data.body;
        if(response.msg === "USER_LOGIN_SUCCESS") {
          localStorage.setItem('userBIH', JSON.stringify(response.user));
          this.accountService.setUser(response.user);
          if(response.user.rol === 1){
            this.router.navigate(['/admin']);
          } else {
            this.router.navigate(['/tours'])
          };
          this.modalService.dismissAll('Cross click');
        } else {
          this.errorLogin = true;
          if(response.msg === "USER_IS_INACTIVE") {
            this.errorMsg = "Su usuario no está habilitado. Debe esperar un correo de confirmación.";
          } else if(response.msg =='Unauthorized Error') {
            this.errorMsg = "Usuario o Contraseña incorrecta.";
          } 
          if (response.msg === undefined) {
            this.errorMsg = 'Problemas con el servidor. Contacte al administrador';       
          }
          this.submitted = false;
          this.form.reset();
        }
      }
    });
            
} 

  openRegister() {
    this.modalService.dismissAll('Cross click');
    const modalRef = this.modalService.open(ModalRegisterComponent, { 
      centered: true,  
      backdrop:'static',      
    }); 
    modalRef.componentInstance.padre = 'login';  
  }

  openRecuperar() {
    this.modalService.dismissAll('Cross click');
    const modalRef = this.modalService.open(ModalRecuperarComponent, { 
      centered: true,  
      backdrop:'static',       
    });    
    modalRef.componentInstance.padre = 'login';
  }

}
